import { RefObject, useEffect, useState } from 'react';

function on<T extends Window | Document | HTMLElement | EventTarget>(
  obj: T | null,

  ...args: Parameters<T['addEventListener']> | [string, Function | null, ...any]
): void {
  if (obj?.addEventListener) {
    obj.addEventListener(
      ...(args as Parameters<HTMLElement['addEventListener']>)
    );
  }
}

function off<T extends Window | Document | HTMLElement | EventTarget>(
  obj: T | null,
  ...args:
    | Parameters<T['removeEventListener']>
    | [string, Function | null, ...any]
): void {
  if (obj?.removeEventListener) {
    obj.removeEventListener(
      ...(args as Parameters<HTMLElement['removeEventListener']>)
    );
  }
}

export const useScrolling = (
  ref: HTMLElement | undefined | null,
  minTop = 0
): boolean => {
  const [scrolling, setScrolling] = useState<boolean>(false);

  useEffect(() => {
    if (ref) {
      const handleScroll = () => {
        setScrolling(ref.scrollTop >= minTop);
      };

      on(ref, 'scroll', handleScroll, false);
      return () => {
        if (ref) {
          off(ref, 'scroll', handleScroll, false);
        }
      };
    }
    return () => {};
  }, [ref, minTop]);

  return scrolling;
};
